import type { Component } from 'solid-js';
import { Button } from '~/shared/ui/Button';

export interface NotForYouCopy {
  title: string;
  body: string;
}

export const notForYouCopy = (roles: readonly string[]): NotForYouCopy =>
  roles.length > 0 && roles.every((r) => r === 'client')
    ? {
        title: 'Сессия сотрудника закончилась — войдите заново',
        body: 'Панель администрации открывается после входа сотрудника. Выйдите и войдите снова — с паролем и кодом из SMS.',
      }
    : {
        title: 'Эта панель — для администрации клуба',
        body:
          'Тренеру она не нужна: расписание, занятия и ученики живут в мобильном приложении. Войдите в него под тем же '
          + 'номером телефона.',
      };

export const NotForYou: Component<{ roles: readonly string[]; onSignOut: () => void }> = (props) => {
  const copy = () => notForYouCopy(props.roles);
  return (
    <div class="min-h-screen flex items-center justify-center p-8">
      <div class="max-w-md text-center">
        <p class="text-[17px] font-semibold text-primary">{copy().title}</p>
        <p class="mt-2 text-[14px] text-secondary">{copy().body}</p>
        <div class="mt-6">
          <Button variant="secondary" onClick={() => props.onSignOut()}>
            Выйти
          </Button>
        </div>
      </div>
    </div>
  );
};
